import { LitElement, html, css } from './-global.min.js'

export class HHAccordion extends LitElement {
  static properties = {
    button: { state: true },
    content: { state: true },
    slot: { state: true },
    open: { type: Boolean },
  }

  constructor() {
    super()

    this.open = false
  }

  firstUpdated() {
    super.firstUpdated()
    this.maxHeight = this.getAttribute('max-height')
    this.initAccordion()
  }

  initAccordion() {
    this.slot = this.shadowRoot.querySelector('slot')
    for (const child of this.slot.assignedElements()) {
      if (child.tagName === 'BUTTON') {
        this.button = child
      } else {
        this.content = child
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
        const links = this.querySelectorAll('a')
        if (isMobile) {
          links.forEach((link) => {
            this.button.classList.contains('active')
              ? link.setAttribute('tabindex', 0)
              : link.setAttribute('tabindex', -1)
          })
        }
      }
    }

    this.initAccordionAction()
  }

  initAccordionAction() {
    if (this.button) {
      this.button.addEventListener('click', (e) => {
        const links = this.querySelectorAll('a')

        if (this.classList.contains('active')) {
          this.content.style.maxHeight = null
          this.button.setAttribute('aria-expanded', 'false')
          this.classList.remove('active')
        } else {
          this.content.style.maxHeight =
            this.maxHeight ?? `${this.content.scrollHeight}px`
          this.button.setAttribute('aria-expanded', 'true')
          this.classList.add('active')
        }

        this.toggleTabIndex(links)
      })
    }
  }

  toggleTabIndex(links) {
    links.forEach((link) => {
      this.button.classList.contains('active')
        ? link.setAttribute('tabindex', 0)
        : link.setAttribute('tabindex', -1)
    })
  }

  static styles = css`
    .accordion-wrapper {
      display: var(--hh-display);
      flex-direction: var(--hh-flex-direction);
    }
  `

  render() {
    return html`
      <div class="accordion-wrapper">
        <slot></slot>
      </div>
    `
  }
}

customElements.define('hh-accordion', HHAccordion)
